import {Injectable} from '@angular/core';
import {StateService} from "@uirouter/core";
import * as _ from 'lodash';

import {DatabaseService} from "../database.service";
import {MenuService} from "../menu.service";
import {ParametersService} from "../parameters.service";
import {
    AlarmTile,
    CirclePoint,
    MenuElement,
    ModuleStatus,
    OtherTilesContainer,
    TileContainer,
    TilesContainer,
    TilesData, TileType6,
    UniversalTileView,
} from "../../models";

@Injectable({
    providedIn: 'root'
})
export class TilesService {
    alarm: AlarmTile[] = [];
    container: TilesContainer[] | {} = {};
    createContainer: boolean = false;
    withoutContainer: OtherTilesContainer = {
        elements: [],
        expanded: false,
    };

    constructor(
        private database: DatabaseService,
        private menu: MenuService,
        private parameters: ParametersService,
        private $state: StateService,
    ) {
        this.createContainer = Object.keys(this.container).length > 0;
    }

    clearTiles(): void {
        this.container = [];
        this.withoutContainer = {
            elements: [],
            expanded: false,
        }
        this.alarm = [];
    }

    registerModule(): void {
        this.$state.go('settings.registration_new_module', {
            selectedModuleHash: this.parameters.selectedModuleHash
        });
    }

    getTiles(orderedTiles: TilesData[]): void {
        this.clearTiles();
        let count = 0;

        orderedTiles.forEach((tile) => {
            if (tile.type === 3 && !tile.orderId) tile.orderId = 0;

            if (tile.type === 60) {
                const containerTile = tile as TileContainer;
                if (containerTile.menuId) {
                    this.menu.getElementMenu(tile.menuId);
                    containerTile.elementMenu = _.cloneDeep(this.menu.elementMenu);
                }

                this.container[count] = {};
                this.container[count].values = containerTile;
                this.container[count].values.count = 0;
                this.container[count].elements = [];

                if (containerTile.expanded === null) this.container[count].values.expanded = false;

                orderedTiles.forEach((value) => {
                    if (value.type !== 'clear_alarm' && value.parentId == tile.id) {
                        this.container[count].elements.push(value);
                        if (value.visibility) {
                            this.container[count].values.count += 1;
                        }
                    }
                });

                count++;
            } else if (tile.type === 'alarm') {
                this.alarm.push(tile);
            } else {
                if (tile.type !== 'clear_alarm' && tile.parentId === 0) {
                    if (tile.menuId) {
                        this.menu.getElementMenu(tile.menuId);
                        tile.elementMenu = _.cloneDeep(this.menu.elementMenu);
                    }

                    this.withoutContainer.elements.push(tile);

                    const otherContainerOrder = this.database.tilesOrder.find(order => order.id === 0);
                    this.withoutContainer.expanded = otherContainerOrder ? otherContainerOrder.expanded : true;
                }
            }
        });

        this.createContainer = Object.keys(this.container).length > 0;

        if (!this.createContainer) {
            this.alarm.forEach((val) => {
                val.orderId = -1;
                this.withoutContainer.elements.unshift(val);
            });
            this.alarm = [];
        }
    }

    setUniversalTile(elementMenu: MenuElement, tile: TileType6): UniversalTileView {
        const universalTile: UniversalTileView = {};

        const type = tile.params.widget2.type > 0
            ? tile.params.widget2.type
            : tile.params.widget1.type > 0
                ? tile.params.widget1.type
                : '';

        switch (type) {
            case 9:
            case 1:
                universalTile.type = 9;
                universalTile.correctValue = elementMenu && tile.params.widget1.unit > 0 ? tile.params.widget1.value : "";
                universalTile.correctFormat = elementMenu && tile.params.widget1.unit > 0 ? tile.params.widget1.unit : "";
                universalTile.value1 = elementMenu ? elementMenu.type == 1 || elementMenu.type == 2 || elementMenu.type == 106 ? elementMenu.params.value : '' : tile.params.widget1.value;
                universalTile.value1Format = elementMenu ? elementMenu.type == 1 ? 0 : elementMenu.type == 2 ? 4 : tile.params.widget1.unit : tile.params.widget1.unit;
                universalTile.value1Unit = elementMenu ? elementMenu.type == 1 || elementMenu.type == 2 ? elementMenu.params.txtId : 0 : 0;
                universalTile.value2 = tile.params.widget2.value;
                universalTile.value2Format = tile.params.widget2.unit;
                break;
            case 2:
                universalTile.type = 2;
                universalTile.value = tile.params.widget2.type > 0 ? tile.params.widget2.value : tile.params.widget1.value;
                universalTile.unit = tile.params.widget2.type > 0 ? tile.params.widget2.unit : tile.params.widget1.unit;
                break;
            case 3:
                universalTile.type = 3;
                universalTile.value = tile.params.widget2.type > 0 ? tile.params.widget2.value : tile.params.widget1.value;
                universalTile.unit = tile.params.widget2.type > 0 ? tile.params.widget2.unit : tile.params.widget1.unit;
                break;
            case 4:
                universalTile.type = 4;
                universalTile.value = tile.params.widget2.type > 0 ? tile.params.widget2.value : tile.params.widget1.value;
                universalTile.unit = tile.params.widget2.type > 0 ? tile.params.widget2.unit : tile.params.widget1.unit;
                universalTile.wheelPoints = this.getWheelPoints(universalTile.value);
                break;
            case 5:
                universalTile.type = 5;
                universalTile.value = tile.params.widget2.type > 0 ? tile.params.widget2.value : tile.params.widget1.value;
                universalTile.unit = tile.params.widget2.type > 0 ? tile.params.widget2.unit : tile.params.widget1.unit;
                universalTile.rotate = (1.8 * universalTile.value) - 90;
                break;
            case 6:
                universalTile.type = 6;
                universalTile.value = tile.params.widget2.type > 0 ? tile.params.widget2.value : tile.params.widget1.value;
                break;
            case 7:
                universalTile.type = 7;
                universalTile.value = tile.params.widget2.type > 0 ? tile.params.widget2.value : tile.params.widget1.value;
                universalTile.unit = tile.params.widget2.type > 0 ? tile.params.widget2.unit : tile.params.widget1.unit;
                // universalTile.color = tile.params.widget2.type > 0 ? tile.params.widget2.params : tile.params.widget1.params;
                universalTile.color = universalTile.color ? universalTile.color : '#C5011C';
                break;
            case 8:
                universalTile.type = 8;
                universalTile.value = tile.params.widget2.type > 0 ? tile.params.widget2.value : tile.params.widget1.value;
                universalTile.value = elementMenu ? elementMenu.params['value'] : '';
                // universalTile.graphPoints = tile.params.widget2.type > 0 ? tile.params.widget2.params : tile.params.widget1.params;
                universalTile.graphPoints = [5, 25, 15, 25, 5];
                universalTile.fieldLine = this.getFieldLineIcon(universalTile.graphPoints);
                break;
        }
        return universalTile;
    }

    private getFieldLineIcon(graphPoints: number[]): string[] {
        let line = '';
        let field = 'M 3,30';
        let tmpX = 0;
        let tmpY = 0;
        const table: string[] = [];

        graphPoints.forEach((value, key) => {
            tmpX = key*11+3;
            tmpY = 30-value;
            field+='L '+tmpX+', '+tmpY;
            line+=(key == 0 ? 'M' : 'L');
            line+= " "+tmpX+ ', '+tmpY;
        });
        table.push(field);
        table.push(line);
        return table;
    }

    private getWheelPoints(value: number): CirclePoint[] {
        const wheelPoints: CirclePoint[] = [];

        for (let i = 0; i < (0.36 * value); i++) {
            wheelPoints.push(this.calculateCoordinate(25, 25, 23, i * 10));
        }

        return wheelPoints;
    }

    calculateCirclePoints(x: number, y: number, r: number,
        angleBegin: number, angleSet: number, width: number
    ): string {
        angleSet = angleSet >=360 ? 359.999 : angleSet;
        const circlePoint1 = this.calculateCoordinate(x, y, r, angleSet);
        const circlePoint2 = this.calculateCoordinate(x, y, r-width, angleSet);
        const circleValue = (angleSet - angleBegin) <= 180 ? 0 :1;

        return 'M ' + (circlePoint2.x *1.0) +','+ (circlePoint2.y *1.0) +' L '
            + (circlePoint1.x *1.0) +', '+ (circlePoint1.y *1.0) +' A '+ r +', '
            + r + ' 0 '+ circleValue +' 0 '+ x +' '+ (y-r) +' L '+ x +', '
            + (y-r+width) +' A '+ (r-width) + ', '+ (r-width) + ' 0 ' + circleValue
            + ' 1 ' + (circlePoint2.x *1.0) + ' ' + (circlePoint2.y * 1.0);
    }

    private calculateCoordinate(circleX: number, circleY: number, r: number, angle: number): CirclePoint {
        const angleRadial = (angle - 90) * (Math.PI / 180.0);
        return {
            x: circleX + (r * Math.cos(angleRadial)),
            y: circleY + (r * Math.sin(angleRadial))
        }
    }

    openSubmenu(element: MenuElement): void {
        const selectedModuleStatus: ModuleStatus = {
            moduleStatus: true,
            controllerStatus: true,
        }

        const parent = this.getParent(element);

        if(!parent) {
            return;
        }
        this.menu.runMenu = true;
        this.$state.go('menu', {selectedModuleHash: this.parameters.selectedModuleHash});

        this.menu.showSubmenu(this.menu.mainMenu[parent.menuType], selectedModuleStatus);
        this.menu.getMenuChild(parent);
        this.menu.getBreadcrumbs(parent);
    }

    private getParent(element: MenuElement): MenuElement {
        let parent: MenuElement;

        if(Array.isArray(this.menu.allElementMenu)){
            this.menu.allElementMenu.forEach((val: MenuElement) => {
                if (element.parentId == val.id && element.menuType === val.menuType) {
                    parent = val;
                }
            });
        }

        return parent;
    }

    deleteAlarm(id: number): void {
        this.alarm = this.alarm.filter(alarm => alarm.id !== id);

        const oldTilesValues = this.database.tiles.getValue();
        if (Array.isArray(oldTilesValues)) {
            this.database.tiles.next(oldTilesValues.filter(tile => tile.id !== id));
        }

        if (this.withoutContainer.elements.length) {
            this.withoutContainer.elements = this.withoutContainer.elements
                .filter(tile => tile.type !== 'alarm' || tile.type === 'alarm' && tile.id !== id);
        }
    }
}
